'use strict';

angular.module('licensure.services')
    .factory('LicenseCategoryLevels', ['$http', '$q', 'Licenses', function ($http, $q, Licenses) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/licensecategorylevels', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getCheckCategory: function (licenseID, code) {
                var d = $q.defer();

                Licenses.getByID(licenseID).then(function (license) {
                    if (code == 'ProviderLicenseHistory' && !license.license_category.provider) {
                        d.resolve(get({ provider: true }));
                    }
                    else if (code == 'DispatcherLicenseHistory' && !license.license_category.dispatcher) {
                        d.resolve(get({ dispatcher: true }));
                    }
                    else if (code == 'InstructorLicenseHistory' && !license.license_category.instructor) {
                        d.resolve(get({ instructor: true }));
                    }
                    else if (code == 'ServiceLicenseLevel' && !license.license_category.service) {
                        d.resolve(get({ service: true }));
                    }
                    else {
                        d.resolve(get({ license_id: licenseID }));
                    }
                })

                return d.promise;
            },

            getProvider: function (args) {
                args.provider = true;
                return get(args);
            },

            getLookupProvider: function (args) {
                args.provider = true;
                args.lookup = true;
                return get(args);
            },

            getVehicle: function (args) {
                args.vehicle = true;
                return get(args);
            },

            getService: function (args) {
                args.service = true;
                return get(args);
            },

            getLookupService: function (args) {
                args.service = true;
                args.lookup = true;
                return get(args);
            },

            getUserLevels: function () {
                return get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' });
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategorylevels/' + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_category_level, license_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecategorylevels/';
                if (!isUndefined(license_category_level.id)) {
                    method = 'PUT'
                    url += license_category_level.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category_level: license_category_level,
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;